<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Sobre a Zimmer';
</script>

<PageHeader title={titlePage} type={1}>
	<span slot="content">
		<h2 class="color-secondary">Quem Somos</h2>
	</span>
</PageHeader>

<div class="container" style="min-height: 400px;">

	<span class="float-sm-left mr-40 mb-40" style="width: 535px; text-align: center;">
		<div>
			<picture class="image-gallery float-sm-left" style="display: flex;">
				<img class="img-fluid" src="assets/images/imgSobre.jpg" alt="Sobre a Empresa">
			</picture>
		</div>
	</span>
	<br />
	<p>A empresa foi fundada em 1999, com objetivo de suprir o vácuo empresarial, no setor de fornecimento qualificado de serviços imobiliários.</p>
	<p>Preza pelo atendimento personalizado e qualificado de seus clientes, a fim de obter a satisfação total. Para desempenhar esta tarefa conta com uma equipe de colaboradores em treinamento constante, e um moderno sistema informatizado.</p>
	<p>A Zimmer Assessoria Imobiliária tem como filosofia de trabalho que o melhor de si é pouco para a satisfação de seu cliente.</p>
	<p>A empresa trabalha junto ao mercado de Aluguéis, Condomínios e Vendas, com extrema agilidade e competência.</p>
	<p>A idéia e o objetivo de nossas ações é levar a empresa onde o cliente necessite dela, sempre prestando o melhor serviço.</p>
	<p>Filiada ao SECOVI/AGADEMI/RS</p>
	<br />
	<hr>
	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/contato" use:link replace title="Entre em Contato" class="btn btn-primary">Entre me contato <i class="far fa-arrow-right"></i></a>
	</div>
	<br />

</div>